import script from "./AbnormalOrderList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"
export * from "./AbnormalOrderList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"

const __exports__ = script;

export default __exports__